export default __webpack_public_path__ + "static/media/lockheed.e37cb3fc.png";